import React from "react"
import Auxiliary from "../../util/Auxiliary"

export default class DefaultPageV1 extends React.Component {
  render() {
    return <Auxiliary loading={true}></Auxiliary>
  }
}
